import { GET_HISTORY_SUCCESS } from './history.types';

const initialState = {
  historyList: null,
};

export const historyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HISTORY_SUCCESS:
      return {
        ...state,
        historyList: action.payload,
      };
    default:
      return state;
  }
};
